// synced from loomweb TextBlockView markdown config (host react-markdown).
/**
 * Markdown renderer for replayed text blocks. loomweb's TextBlockView renders a
 * `TextBlock.content` string through react-markdown with a large custom component
 * map (markdown/*). This host already ships react-markdown + remark-gfm and has
 * no Tailwind, so we render the same content through them inside a namespaced
 * `.replay-md` container (styled in styles/loom-replay.css). react-markdown does
 * not render raw HTML by default, so this stays XSS-safe for replayed content.
 */
import type { JSX } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function ReplayMarkdown({ children }: { children: string }): JSX.Element {
  return (
    <div className="replay-md">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children: c }) => (
            <a href={href ?? "#"} target="_blank" rel="noopener noreferrer">
              {c}
            </a>
          )
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
